import { render, staticRenderFns } from "./DocumentSuccessDialog.vue?vue&type=template&id=783ef59a"
import script from "./DocumentSuccessDialog.vue?vue&type=script&lang=js"
export * from "./DocumentSuccessDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports